<template>
  <cst-page-template :loading-overlay="true">
    <quote-status :closable="true" />

    <div class="customer-configuration-page__wrapper">
      <div class="customer-configuration-page__column customer-configuration-page__column-1">
        <a class="customer-configuration-page__back-button" @click="goBack">
          <icon icon="angle-left" /> {{ i18n.t('/QuotePage/BackButton') }}
        </a>

        <div
          class="customer-configuration-page__block customer-configuration-page__block--expandable"
        >
          <add-customer />
        </div>
        <div
          class="customer-configuration-page__block customer-configuration-page__block--expandable"
        >
          <add-company />

          <reference-leaseportal />
          <unlink-customer />
        </div>
        <div
          class="customer-configuration-page__block customer-configuration-page__block--expandable"
        >
          <customer-type :is-b2b="true" />
        </div>
        <div
          class="customer-configuration-page__block customer-configuration-page__block--expandable"
        >
          <add-lease-company :is-b2b="true" />
        </div>
        <div
          class="customer-configuration-page__block customer-configuration-page__block--expandable"
        >
          <add-fleet-sales-contract />
        </div>

        <div class="customer-configuration-page__actions">
          <save-quote-button :title="i18n.t('/QuoteActions/PreviewSaveButton')" />
        </div>
      </div>

      <div class="customer-configuration-page__column customer-configuration-page__column-2">
        <div class="customer-configuration-page__main-center">
          <h1 class="customer-configuration-page__header-text">
            {{ i18n.t('/QuotePage/Title') }}
          </h1>

          <div class="customer-configuration-page__actions configurationcode-header">
            <h5 style="display: inline">
              {{ i18n.t('/Configuration/BlockTitle') }}
            </h5>
            <div class="configuration-actions--wrapper">
              <configuration-code-container v-if="!isStockCar" :order-service="orderService" />
              <stock-match-container v-if="!isStockCar" />
            </div>
            <stock-order-info-block v-if="isStockCar" />
          </div>
        </div>

        <div class="customer-configuration-page__block">
          <configuration-summary :enable-no-bpm="true" />
        </div>

        <div class="customer-configuration-page__block customer-configuration-page__controlcodes">
          <control-codes :order-service="orderService" />
        </div>

        <div
          class="customer-configuration-page__block customer-configuration-page__block--no-shrink"
        >
          <print-options />
        </div>

        <div class="customer-configuration-page__actions">
          <quote-actions
            :check-customer-type="true"
            :check-expire-date="true"
            :check-expected-delivery-date="true"
          />
        </div>
      </div>

      <div class="customer-configuration-page__column customer-configuration-page__column-3">
        <div>
          <quote-info />
        </div>

        <div class="customer-configuration-page__block">
          <dealer-accessory-catalog
            v-if="useNewAccessoryCatalog"
            class="customer-configuration-page__detail-costs"
          />
          <dealer-accessories v-else class="customer-configuration-page__detail-costs" />
          <delivery-costs class="customer-configuration-page__detail-costs" />
          <settle :start-expanded="true" class="customer-configuration-page__detail-costs" />
          <corrections class="customer-configuration-page__detail-costs" />
        </div>

        <div class="customer-configuration-page__block">
          <exchange-car-form />
        </div>

        <div
          class="customer-configuration-page__block customer-configuration-page__block--no-shrink customer-configuration-page__proposition"
        >
          <proposition-block />
          <total-price-block />
        </div>
      </div>
    </div>
  </cst-page-template>
</template>

<script>
import quoteOrderService from '@/services/quoteOrderService.js'
import ConfigurationSummary from '@/components/generic/presentational/organisms/configurationSummary/ConfigurationSummary.vue'
import PrintOptions from '@/components/generic/presentational/organisms/printOptions/PrintOptions.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import SaveQuoteButton from '@/components/generic/presentational/molecules/saveQuoteButton/SaveQuoteButton.vue'
import AddCustomer from '@/components/generic/presentational/organisms/addCustomer/AddCustomer.vue'
import AddCompany from '@/components/generic/presentational/organisms/addCompany/AddCompany.vue'
import AddCompanyExtraDetails from '@/components/generic/presentational/organisms/addCompany/AddCompanyExtraDetails.vue'
import UnlinkCustomer from '@/components/generic/presentational/molecules/unlinkCustomer/UnlinkCustomer.vue'
import AddLeaseCompany from '@/components/generic/presentational/organisms/addLeaseCompany/AddLeaseCompany.vue'
import AddFleetSalesContract from '@/components/generic/presentational/organisms/addFleetSalesContract/AddFleetSalesContract.vue'
import TotalPriceBlock from '@/components/generic/presentational/organisms/totalPriceBlock/TotalPriceBlock.vue'
import ControlCodes from '@/components/generic/container/ControlCodes.vue'
import DealerAccessories from '@/components/generic/container/DealerAccessories.vue'
import DealerAccessoryCatalog from '@/components/generic/container/DealerAccessoryCatalog.vue'
import DeliveryCosts from '@/components/generic/container/DeliveryCosts.vue'
import Corrections from '@/components/generic/container/Corrections.vue'
import Settle from '@/components/generic/container/Settle.vue'
import QuoteActions from '@/components/generic/presentational/organisms/quoteActions/QuoteActions.vue'
import ConfigurationCodeContainer from '@/components/generic/container/ConfigurationCodeContainer.vue'
import StockMatchContainer from '@/components/generic/container/StockMatchContainer.vue'
import PropositionBlock from '@/components/generic/presentational/molecules/propositionBlock/PropositionBlock.vue'
import ExchangeCarForm from '@/components/generic/presentational/organisms/exchangeCarForm/ExchangeCarForm.vue'
import ReferenceLeaseportal from '@/components/generic/presentational/organisms/referenceLeaseportal/ReferenceLeaseportal.vue'
import CustomerType from '@/components/generic/presentational/organisms/customerType/CustomerType.vue'

import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import QuoteInfo from '@/components/generic/presentational/molecules/quoteInfo/QuoteInfo.vue'
import StockOrderInfoBlock from '@/components/generic/presentational/organisms/stockOrderInfoBlock/StockOrderInfoBlock.vue'

import QuoteStatus from '@/components/generic/presentational/molecules/quoteStatus/quoteStatus.vue'

import { mapState } from 'vuex'

export default {
  components: {
    DealerAccessoryCatalog,
    ConfigurationSummary,
    PrintOptions,
    Icon,
    AddCustomer,
    AddCompany,
    AddFleetSalesContract,
    AddLeaseCompany,
    ControlCodes,
    DealerAccessories,
    DeliveryCosts,
    Corrections,
    ExchangeCarForm,
    Settle,
    SaveQuoteButton,
    CstPageTemplate,
    QuoteActions,
    TotalPriceBlock,
    StockMatchContainer,
    PropositionBlock,
    ReferenceLeaseportal,
    QuoteInfo,
    ConfigurationCodeContainer,
    StockOrderInfoBlock,
    QuoteStatus,
    CustomerType,
    UnlinkCustomer,
  },
  props: {
    configurationCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loadingQuote: true,
      loadingSave: false,
      quote: null,
      orderService: quoteOrderService,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapState('user', ['dealerSettings']),
    useNewAccessoryCatalog() {
      return this.$store.getters['user/useNewAccessoryCatalog']
    },
    isStockCar() {
      return this.$store.getters['quote/isStockCar']
    },
    establishmentId() {
      return this.$route.params.establishmentId
    },
    quoteId() {
      return this.$route.params.quoteId
    },
    newConfigurationCode() {
      // return from car configurator
      return this.$route.query.configuratie
    },
  },
  async created() {},
  methods: {
    goBack() {
      if (this.$route.query.returnUrl) {
        this.$router.push(this.$route.query.returnUrl)
      } else {
        this.$router.push({
          name: 'quote-overview-page',
          params: {
            cstType: this.$route.params.cstType,
            establishmentId: this.$route.params.establishmentId,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-configuration-page {
  &__wrapper {
    display: flex;
    height: 100vh;
    background: linear-gradient(to bottom, #f1f4f5, whitesmoke, #f1f4f5);
  }

  &__column {
    flex-direction: column;
    display: flex;
    margin-left: 1rem;
    margin-right: 1rem;

    &-1 {
      flex-basis: 20%;
      margin-right: 0;
    }

    &-2 {
      flex-basis: 40%;
    }

    &-3 {
      flex-basis: 40%;
      margin-left: 0;
    }
  }

  &__controlcodes {
    margin-top: auto;
  }

  &__block {
    overflow: hidden;
    overflow-y: auto;
    zoom: 70%;
    box-sizing: border-box;

    margin-bottom: 1.5rem;

    background-color: white;
    padding: 1.5em;
    transition: height 0.25s ease-in;
    flex: initial;

    &--no-shrink {
      flex: 0 0 auto;
    }

    &--expandable {
      flex: 1 1 auto;

      &:hover {
        box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.5);
        flex: 1 0 auto;
        flex-grow: auto;
      }
    }
  }

  &__actions {
    zoom: 70%;
  }

  :deep(&__detail-costs) {
    > div {
      margin-bottom: 0;
    }
  }
}

.customer-configuration-page__back-button {
  text-decoration: none;
}

.customer-configuration-page__header-text {
  font-size: 1em;
  text-align: center;
}

.customer-configuration-page__main-center {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.configurationcode-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  & > h5 {
    width: auto;
    white-space: nowrap;
    margin: 0;
  }
}

.configuration-actions--wrapper {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.customer-configuration-page__block::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.customer-configuration-page__block::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}

.customer-configuration-page__block::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

/* css overrides to reduce space */
:deep(.quote-block .row) {
  padding: 0;
}
</style>
